__turbopack_context__.v({
  "box": "common-textarea-module-scss-module__hrg6kW__box",
  "header": "common-textarea-module-scss-module__hrg6kW__header",
  "header__error": "common-textarea-module-scss-module__hrg6kW__header__error",
  "header__error_visible": "common-textarea-module-scss-module__hrg6kW__header__error_visible",
  "label": "common-textarea-module-scss-module__hrg6kW__label",
  "label_error": "common-textarea-module-scss-module__hrg6kW__label_error",
  "textarea": "common-textarea-module-scss-module__hrg6kW__textarea",
  "textarea_disabled": "common-textarea-module-scss-module__hrg6kW__textarea_disabled",
  "textarea_error": "common-textarea-module-scss-module__hrg6kW__textarea_error",
  "wrapper": "common-textarea-module-scss-module__hrg6kW__wrapper",
  "wrapper_disabled": "common-textarea-module-scss-module__hrg6kW__wrapper_disabled",
  "wrapper_error": "common-textarea-module-scss-module__hrg6kW__wrapper_error",
});
